import React from "react";
import PropTypes from "prop-types";
import { Dialog, DialogContent, DialogTitle, Divider, Switch } from "@material-ui/core";
import styled from "styled-components";
import { useIntl } from "react-intl";
import { compose } from "recompose";
import injectSheet from "react-jss";

import { Flex, Loading, Tipografia } from "../../../../_common";
import EditorTextoNovoEmail from "../../../central-emails/EditorTextoNovoEmail/EditorTextoNovoEmail";
import ModalEscolherTemplate from "../../../central-emails/ModalEscolherTemplate/ModalEscolherTemplate";
import SelectContatos from "./SelectContatos";
import { TIPO_CONTATO } from "./constantes";

const style = () => ({
  spacing: { marginRight: 16, marginLeft: 16, marginBottom: 8 },
  conteudoModal: {
    padding: 0,
  },
  containerConteudoModal: {
    padding: "0 24px 24px",
  },
});

export const EditorEmailStyle = styled.div`
  #campoMensagem {
    min-height: 400px !important;
  }
`;

function DialogNovoEmail({
  cssRootDialog,
  aberto,
  enviarTodosContatos,
  handleAlterarEnviarTodosContatos,
  isLoading,
  templateSelecionado,
  handleExibirTemplate,
  responderEmail,
  callbackEnvio,
  abrirModalTemplates,
  handleSelecionarTemplate,
  atividades,
  setContatosId,
  isContatosValid,
  setIsContatosValid,
  classes,
}) {
  const intl = useIntl();

  return (
    <>
      <Dialog
        className={cssRootDialog}
        maxWidth="lg"
        disableBackdropClick
        disableEscapeKeyDown
        hideBackdrop
        fullWidth
        open={aberto}
        disableEnforceFocus
      >
        <DialogTitle>{intl.formatMessage({ defaultMessage: "Novo e-mail" })}</DialogTitle>
        <DialogContent className={classes.conteudoModal}>
          <Flex flexDirection="column">
            <Divider />
            <Flex id="enviar-todos-contatos" alignItems="center" className={classes.spacing}>
              {atividades.length === 1 ? (
                <SelectContatos
                  lead={atividades[0]?.lead}
                  label={intl.formatMessage({
                    defaultMessage: "Selecionar contatos",
                  })}
                  setContatosId={setContatosId}
                  setIsContatosValid={setIsContatosValid}
                  isContatosValid={isContatosValid}
                  tipoContato={TIPO_CONTATO.EMAIL}
                />
              ) : (
                <>
                  <Switch
                    checked={enviarTodosContatos}
                    onChange={(e, checked) => handleAlterarEnviarTodosContatos(checked)}
                    color="primary"
                  />
                  <Tipografia>
                    {intl.formatMessage({ defaultMessage: "Enviar para todos os contatos dos leads" })}
                  </Tipografia>
                </>
              )}
            </Flex>
            <Divider />
            <Flex id="editor" flexDirection="column" className={classes.containerConteudoModal}>
              <Loading isLoading={isLoading}>
                <EditorEmailStyle>
                  <EditorTextoNovoEmail
                    templateId={templateSelecionado}
                    conteudoTemplate={undefined}
                    conteudoHtml={false}
                    handleExibirTemplate={handleExibirTemplate}
                    linksAnexos={responderEmail.linksAnexos}
                    ocultarDescartarRascunho
                    ocultarBarraDestinatarios
                    enviarEmail={callbackEnvio}
                  />
                </EditorEmailStyle>
              </Loading>
            </Flex>
          </Flex>
        </DialogContent>
      </Dialog>
      <Dialog maxWidth="sm" className={classes.rootDialog} fullWidth open={abrirModalTemplates}>
        <DialogTitle>{intl.formatMessage({ defaultMessage: "Selecione um template" })}</DialogTitle>
        <DialogContent>
          <ModalEscolherTemplate handleSelecionarTemplate={handleSelecionarTemplate} />
        </DialogContent>
      </Dialog>
    </>
  );
}

DialogNovoEmail.propTypes = {
  cssRootDialog: PropTypes.string,
  aberto: PropTypes.bool,
  enviarTodosContatos: PropTypes.bool,
  handleAlterarEnviarTodosContatos: PropTypes.func,
  isLoading: PropTypes.bool,
  templateSelecionado: PropTypes.number,
  handleExibirTemplate: PropTypes.func,
  responderEmail: PropTypes.object,
  callbackEnvio: PropTypes.func,
  abrirModalTemplates: PropTypes.func,
  handleSelecionarTemplate: PropTypes.func,
  atividades: PropTypes.array,
  setContatosId: PropTypes.func,
  setIsContatosValid: PropTypes.func,
  isContatosValid: PropTypes.bool,
};

const enhance = compose(injectSheet(style));

export default enhance(DialogNovoEmail);
